var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckedIconSellCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "42px",
    viewBox: "0 0 42 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Atlm_Saleauto_Landing",
    transform: "translate(-119.000000, -209.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Trade-in",
    transform: "translate(120.000000, 100.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-22",
    transform: "translate(0.000000, 48.909788)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 1,
    transform: "translate(0.000000, 61.090212)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,0 C31.045695,0 40,8.954305 40,20 C40,31.045695 31.045695,40 20,40",
    id: "Rectangle-2-Copy-3",
    stroke: "#0061ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 C11.045695,0 20,8.954305 20,20 C20,31.045695 11.045695,40 0,40",
    id: "Rectangle-2-Copy-4",
    stroke: "#EBECF0",
    transform: "translate(10.000000, 20.000000) scale(-1, 1) translate(-10.000000, -20.000000) "
  })), /*#__PURE__*/React.createElement("g", {
    id: "checked-5",
    transform: "translate(11.000000, 13.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 8.13808451 6.84887772 15 20 1.86194135 18.1119413 0 6.84887772 11.2499321 1.86191219 6.26303117"
  })))))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedIconSellCar);
export default ForwardRef;